<template>
  <div class="header" v-show="!isApp">
    <a
      class="header-back"
      href="javascript:;"
      title
      v-on:click="back()"
      v-stat:click="{ name: 'back' }"
    >
      <em class="iconfont_M icon-back_M"></em>
    </a>
    <p>{{ title }}</p>
  </div>
</template>
<script>
import { backHome } from "../environment/lk_api";
import { isAnb,backLink } from "../environment/anb_api";
export default {
  name: "SocialHeader",
  props: ["title"],
  data() {
    return {
      // 如果是从主app跳转过来的，不显示当前标题头
      isApp: window.entrance.name === "mainapp",
    };
  },
  methods: {
    back: function () {
      const routerName = this.$route.name;
      if (window.entrance.name === "txh") {
        let backType = "popViewController";
        if (routerName === "ActivityHome") {
          backType = "exitViewController";
        }
        try {
          window.ClassmateNative.goNative({
            page: backType, // 'popViewController' 返回上一页，'exitViewController' 退出当前webview
          });
        } catch (e) {
          console.log(e);
        }
      } else if (
        window.entrance.name === "jsj" &&
        routerName === "ActivityHome"
      ) {
        window.AHJavascriptBridge.invoke("popBackWebVC", {}, function (res) {
          console.log(res);
        });
      } else if (
        window.entrance.name === "lk" &&
        routerName === "ActivityHome"
      ) {
        backHome();
      }else if(isAnb()&&routerName === "ActivityHome"){
        backLink();
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/social-header.vue